/**
 * Helpers for geo hierarchy display and placeSync payloads.
 */

export const formatPopulatedLocationLabel = (loc) => {
  if (!loc || typeof loc !== 'object') return '';
  const parts = [
    loc.neighbourhood?.name,
    loc.area?.name,
    loc.city?.name,
    loc.cityRegion?.name,
    loc.region?.name,
    loc.country?.name,
  ].filter(Boolean);
  const address = [loc.address1, loc.postCode].filter(Boolean).join(', ');
  if (parts.length) return parts.join(', ');
  if (address) return address;
  return loc._id || '';
};

export const geoEntityName = (entity) => {
  if (!entity) return '';
  if (typeof entity === 'object') return entity.name || '';
  return '';
};

export const extractPayload = (responseData) => {
  if (!responseData) return {};
  if (responseData.data && typeof responseData.data === 'object') return responseData.data;
  return responseData;
};

export const buildPlaceSyncPayload = (neighbourhoodId, addressFields) => {
  const location = {
    address1: String(addressFields.address1 || '').trim(),
    postCode: String(addressFields.postCode || '').trim(),
    address2: String(addressFields.address2 || '').trim(),
    lat: addressFields.lat != null ? String(addressFields.lat) : '',
    lng: addressFields.lng != null ? String(addressFields.lng) : '',
    googlePlaceId: String(addressFields.googlePlaceId || '').trim(),
  };
  return {
    neighbourhoodId: String(neighbourhoodId),
    location,
  };
};

export const addressFieldsFromPopulatedLocation = (loc) => ({
  address1: loc?.address1 || '',
  postCode: loc?.postCode || '',
  address2: loc?.address2 || '',
  lat: loc?.lat != null ? String(loc.lat) : '',
  lng: loc?.lng != null ? String(loc.lng) : '',
  googlePlaceId: loc?.googlePlaceId || '',
});

export const resolvedGeoFromChain = (chain) => ({
  country: geoEntityName(chain?.country),
  region: geoEntityName(chain?.region),
  cityRegion: geoEntityName(chain?.cityRegion),
  city: geoEntityName(chain?.city),
  area: geoEntityName(chain?.area),
  neighbourhood: geoEntityName(chain?.neighbourhood),
});
